"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNotNil = _interopRequireDefault(require("../../utils/object/isNotNil"));

var _getClampedEndTime = _interopRequireDefault(require("./getClampedEndTime"));

var _creative = require("../../constants/creative");

var getVideoRelativeFrameIndicesAndTimesForFrame = function getVideoRelativeFrameIndicesAndTimesForFrame(contentStartInSeconds, // Start of the video clip
contentEndInSeconds, // End of the video clip
mediaDurationInSeconds) // Frames per second
{
  var elementStartFrame = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var globalFrameIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var // Current Frame
  globalEndTimeInSeconds = arguments.length > 5 ? arguments[5] : undefined;
  var frameRate = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : _creative.PLAYBACK_FRAMES_PER_SECOND;
  // Where the element first appears in the timeline
  var elementStartTime = elementStartFrame / frameRate;
  var startTime;
  var endTime;

  if ((0, _isNotNil["default"])(contentStartInSeconds) && (0, _isNotNil["default"])(contentEndInSeconds)) {
    startTime = contentStartInSeconds;
    endTime = (0, _getClampedEndTime["default"])(startTime, contentEndInSeconds, elementStartTime, globalEndTimeInSeconds);
  } else {
    startTime = 0;
    endTime = (0, _getClampedEndTime["default"])(startTime, mediaDurationInSeconds, elementStartTime, globalEndTimeInSeconds);
  }

  var startIndex = Math.floor(startTime * frameRate);
  var endIndex = Math.floor(endTime * frameRate) - 1;
  var totalFrames = endIndex - startIndex + 1;
  var frameIndex = (globalFrameIndex - elementStartFrame) % totalFrames + startIndex;
  return {
    endIndex: endIndex,
    endTime: endTime,
    frameIndex: frameIndex,
    startIndex: startIndex,
    startTime: startTime,
    totalFrames: totalFrames
  };
};

var _default = getVideoRelativeFrameIndicesAndTimesForFrame;
exports["default"] = _default;